import { COUNTRIES } from "src/common/constants";
import { CountriesActionI } from "../reducers/countries";
import { Country } from "src/types/Country";
export const COUNTRIES_FETCH_DATA = `${COUNTRIES}_GET_DATA` as const;
export const COUNTRIES_FETCH_INVOKED = `${COUNTRIES}_GET_INVOKED` as const;
export const COUNTRIES_FETCH_SUCCESS = `${COUNTRIES}_GET_SUCCESS` as const;
export const COUNTRIES_FETCH_FAILED = `${COUNTRIES}_GET_FAILED` as const;

export const fetchCountries = (isGlobalRiskMap): CountriesActionI => ({
  type: COUNTRIES_FETCH_DATA,
  isGlobalRiskMap,
});
export const fetchCountriesInvoked = (): CountriesActionI => ({
  type: COUNTRIES_FETCH_INVOKED,
});
export const fetchCountriesSuccess = (
  payload: Country[]
): CountriesActionI => ({
  type: COUNTRIES_FETCH_SUCCESS,
  payload,
});
export const fetchCountriesFailed = (error): CountriesActionI => ({
  type: COUNTRIES_FETCH_FAILED,
  error,
});
